import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RxCross1 } from "react-icons/rx";


function AddModule() {

    const navigate = useNavigate();

    const token = sessionStorage.getItem('tokenKey');
    const BASE_URL = process.env.REACT_APP_PP_URL;

    const [title, setTitle] = useState();
    const navToBack = useNavigate();

    const postMasterModule = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/module/save`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    title: title
                })
            })
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                alert(getRes.message);
                navToBack('/admin/managePage')
            }
        } catch (e) {
            console.log(e, 'error in posting marster api')
        }
    };

    return (
        <>
            <div className="add-item">
                <div className="row">
                    <div className="category-nav">
                        <div className="category-text">
                            <h4>Add Modules</h4>
                        </div>
                        <div className="category-btn">
                            <button onClick={() => navigate(-1)}><RxCross1 /></button>
                        </div>
                    </div>
                    <hr />

                    <div className="add-form">
                        <div className="add w-100 m-b2">
                            <label>Module Title</label>
                            <input
                                type="text"
                                name="title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="btn submit-btn">
                        <button onClick={postMasterModule}>Save Modal</button>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AddModule;